import React from 'react';
import PropTypes from 'prop-types';
import SoftBox from 'components/SoftBox';
import SoftTypography from 'components/SoftTypography';
import SoftInput from 'components/SoftInput';

/**
 * PartnerPriceSection – wird in allen Bestellformularen angezeigt wenn isPartner=true.
 * Zeigt den Einkaufspreis (mit 20%-Rabatt) und ein optionales Feld für den Endkundenpreis.
 */
function PartnerPriceSection({ standardPrice, purchasePrice, endCustomerPrice, onChange }) {
  return (
    <SoftBox
      mt={2}
      mb={1}
      p={2}
      borderRadius="lg"
      style={{ background: 'rgba(139,0,0,0.06)', border: '1px solid rgba(139,0,0,0.18)' }}
    >
      <SoftTypography variant="h6" fontWeight="medium" mb={1} style={{ color: '#8b0000' }}>
        Partner-Preisübersicht
      </SoftTypography>

      <SoftBox display="flex" flexDirection="column" style={{ gap: 4 }} mb={1.5}>
        <SoftBox display="flex" alignItems="center" style={{ gap: 8 }}>
          <SoftTypography variant="button" fontWeight="regular" color="text" style={{ minWidth: 160 }}>
            UDS-Listenpreis:
          </SoftTypography>
          <SoftTypography
            variant="button"
            fontWeight="regular"
            style={{ textDecoration: 'line-through', color: '#888' }}
          >
            {standardPrice > 0 ? standardPrice.toFixed(2) : '–'} €/Monat
          </SoftTypography>
        </SoftBox>

        <SoftBox display="flex" alignItems="center" style={{ gap: 8 }}>
          <SoftTypography variant="button" fontWeight="medium" color="text" style={{ minWidth: 160 }}>
            Ihr Einkaufspreis:
          </SoftTypography>
          <SoftTypography variant="button" fontWeight="bold" style={{ color: '#8b0000' }}>
            {purchasePrice > 0 ? purchasePrice.toFixed(2) : '–'} €/Monat
          </SoftTypography>
          <SoftTypography variant="caption" color="text" style={{ color: '#666' }}>
            (20% Partner-Rabatt)
          </SoftTypography>
        </SoftBox>
      </SoftBox>

      <SoftBox>
        <SoftTypography variant="button" fontWeight="medium" color="text" display="block" mb={0.5}>
          Endkundenpreis für Ihren Kunden (optional):
        </SoftTypography>
        <SoftBox display="flex" alignItems="center" style={{ gap: 8 }}>
          <SoftBox style={{ maxWidth: 180 }}>
            <SoftInput
              type="number"
              value={endCustomerPrice}
              onChange={(e) => onChange(e.target.value)}
              placeholder="z.B. 49.99"
              inputProps={{ min: 0, step: 0.01 }}
            />
          </SoftBox>
          <SoftTypography variant="button" fontWeight="regular" color="text">
            €/Monat
          </SoftTypography>
        </SoftBox>
        <SoftTypography variant="caption" color="secondary" display="block" mt={0.5}>
          Leer lassen = Kunden sehen den UDS-Standardpreis
        </SoftTypography>
      </SoftBox>
    </SoftBox>
  );
}

PartnerPriceSection.propTypes = {
  standardPrice: PropTypes.number.isRequired,
  purchasePrice: PropTypes.number.isRequired,
  endCustomerPrice: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default PartnerPriceSection;
